import App from "../App.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Main from "../views/Main.vue";

import Explore from "../views/explore/Explore.vue";
import Discover from "../views/discover/Discover.vue";
import User from "../views/user/User.vue";

import BottomTabbar from "../views/memorialhall/BottomTabbar.vue";
import MemorialHall from "../views/memorialhall/MemorialHall.vue";
import Life from "../views/memorialhall/life/Life.vue";
import Photos from "../views/memorialhall/photos/Photos.vue";
import Memory from "../views/memorialhall/memory/Memory.vue";
import Mailbox from "../views/memorialhall/mailbox/Mailbox.vue";
import AddressManage from "../views/user/addressManage/Index.vue";
import AddressManageAdd from "../views/user/addressManage/Add.vue";
import AddressManageEdit from "../views/user/addressManage/Edit.vue";
import JifenGiveForm from "../views/user/jifen/JifenGiveForm.vue";
import yeGiveForm from "../views/user/jifen/yeGiveForm.vue";
import yeGiveForm2 from "../views/user/jifen/yeGiveForm2.vue";
import yeGive  from '../views/user/jifen/yeGive.vue';
import JifenDetails from "../views/user/jifen/JifenDetails.vue"; 
import JifenGive from "../views/user/jifen/jifenGive.vue";
import Zy from "../views/memorialhall/zy/index.vue";
import ZyTest from "../views/memorialhall/zy/test.vue";
import SignIn from '../views/signIn/index.vue';
import MemorialHallApply from '../views/memorialhall/memorialHallApply/index'


const memberDetails = (r) =>
  require.ensure(
    [],
    () => r(require("../views/user/member/MemberDetails.vue")),
    "memberDetails"
  );
const mProductList = (r) =>
  require.ensure(
    [],
    () => r(require("../views/user/member/MProductList.vue")),
    "mProductList"
  );

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: App,
    children: [
      {
        path: "/",
        component: Main,
        redirect: "/Home", // 默认显示的子路由
        children: [
          {
            path: "/Home",
            name: "Home",
            component: Home,
            meta: {
              requiresAuth: true,
              // keepAlive: true, // 需要被缓存
              refresh: false
            },
          },
          {
            path: "/Explore",
            name: "Explore",
            component: Explore,
            meta: {
              keepAlive: true, // 需要被缓存
            },
          },
          {
            path: "/Discover",
            name: "Discover",
            component: Discover,
            meta: {
              // keepAlive: true, // 需要被缓存
            },
          },
          {
            path: "/User",
            name: "User",
            component: User,
            meta: {
              requiresAuth: true,
              // keepAlive: true, // 需要被缓存
              refresh: false,
            },
          },
        ],
      },
      {
        path: "/MemberDetails",
        name: "MemberDetails",
        component: memberDetails,
        meta: {
          keepAlive: true,
          isBack: false,
        },
      },
      {
        path: "/MProductList",
        name: "MProductList",
        component: mProductList,
        meta: {
          keepAlive: true,
          isBack: false,
        },
      },
    ],
  },
  /*
  {
    path: "/",
    name: "Home",
    component: Home
  },
  */
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // },

  {
    path: "/BottomTabbar",
    component: BottomTabbar,
    children: [
      {
        path: "/MemorialHall",
        name: "MemorialHall",
        component: MemorialHall,
        meta: {
          keepAlive: true, // 需要被缓存
        },
      },
      {
        path: "/Life",
        name: "Life",
        component: Life,
        meta: {
          keepAlive: true, // 需要被缓存
        },
      },
      {
        path: "/Photos",
        name: "Photos",
        component: Photos,
        meta: {
          keepAlive: true, // 需要被缓存
        },
      },
      {
        path: "/Memory",
        name: "Memory",
        component: Memory,
        meta: {
          keepAlive: true, // 需要被缓存
        },
      },
      {
        path: "/Mailbox",
        name: "Mailbox",
        component: Mailbox,
        meta: {
          keepAlive: true, // 需要被缓存
        },
      },
    ],
  },
  {
    path: "/VisitorList",
    name: "VisitorList",
    component: () => import("../views/memorialhall/visitor/VisitorList.vue"),
  },
  {
    path: "/PersonInfo",
    name: "PersonInfo",
    component: () => import("../views/memorialhall/visitor/PersonInfo.vue"),
  },
  {
    path: "/TemplateList",
    name: "TemplateList",
    component: () => import("../views/memorialhall/template/TemplateList.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/LifeEdit",
    name: "LifeEdit",
    component: () => import("../views/memorialhall/life/LifeEdit.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/HallInfoEdit",
    name: "HallInfoEdit",
    component: () => import("../views/memorialhall/life/HallInfoEdit.vue"),
  },
  {
    path: "/MusicAdd",
    name: "MusicAdd",
    component: () => import("../views/memorialhall/photos/MusicAdd.vue"),
  },
  {
    path: "/MusicDetails",
    name: "MusicDetails",
    component: () => import("../views/memorialhall/photos/MusicDetails.vue"),
  },
  {
    path: "/VideoAdd",
    name: "VideoAdd",
    component: () => import("../views/memorialhall/photos/VideoAdd.vue"),
  },
  {
    path: "/VideoDetails",
    name: "VideoDetails",
    component: () => import("../views/memorialhall/photos/VideoDetails.vue"),
  },
  {
    path: "/ImageAdd",
    name: "ImageAdd",
    component: () => import("../views/memorialhall/photos/ImageAdd.vue"),
  },
  {
    path: "/ImageItemAdd",
    name: "ImageItemAdd",
    component: () => import("../views/memorialhall/photos/ImageItemAdd.vue"),
  },
  {
    path: "/ImageDetails",
    name: "ImageDetails",
    component: () => import("../views/memorialhall/photos/ImageDetails.vue"),
  },
  {
    path: "/MailboxAdd",
    name: "MailboxAdd",
    component: () => import("../views/memorialhall/mailbox/MailboxAdd.vue"),
  },
  {
    path: "/MemoryAdd",
    name: "MemoryAdd",
    component: () => import("../views/memorialhall/memory/MemoryAdd.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/MemoryDetails",
    name: "MemoryDetails",
    component: () => import("../views/memorialhall/memory/MemoryDetails.vue"),
  },
  {
    path: "/MemoryComment",
    name: "MemoryComment",
    component: () => import("../views/memorialhall/memory/MemoryComment.vue"),
  },
  {
    path: "/Worship",
    name: "Worship",
    component: () => import("../views/memorialhall/worship/Worship.vue"),
  },
  {
    path: "/Cemetery",
    name: "Cemetery",
    component: () => import("../views/memorialhall/worship/Cemetery.vue"),
  },
  {
    path: "/GiftList",
    name: "GiftList",
    component: () => import("../views/memorialhall/worship/GiftList.vue"),
    meta: {
      requiresAuth: true,
      // keepAlive: true,
      refresh: false
    },
  },
  {
    path: "/GiftList2",
    name: "GiftList2",
    component: () => import("../views/memorialhall/worship/GiftList2.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      refresh: false
    },
  },
  {
    path: "/GiftPackageDetails",
    name: "GiftPackageDetails",
    component: () =>
      import("../views/memorialhall/worship/GiftPackageDetails.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/GiftPackageDetails2",
    name: "GiftPackageDetails2",
    component: () =>
      import("../views/memorialhall/worship/GiftPackageDetails2.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/GiftRecord",
    name: "GiftRecord",
    component: () => import("../views/memorialhall/worship/GiftRecord.vue"),
  },
  {
    path: "/GiftRecord2",
    name: "GiftRecord2",
    component: () => import("../views/memorialhall/worship/GiftRecord2.vue"),
  },
  {
    path: "/GiftDetails",
    name: "GiftDetails",
    component: () => import("../views/memorialhall/worship/GiftDetails.vue"),
  },
  {
    path: "/MemorialHallSet",
    name: "MemorialHallSet",
    component: () => import("../views/memorialhall/set/MemorialHallSet.vue"),
  },
  {
    path: "/MemorialHallUpgrade",
    name: "MemorialHallUpgrade",
    component: () =>
      import("../views/memorialhall/set/MemorialHallUpgrade.vue"),
  },
  {
    path: "/MemorialHallMusic",
    name: "MemorialHallMusic",
    component: () => import("../views/memorialhall/set/MemorialHallMusic.vue"),
  },
  {
    path: "/UserEdit",
    name: "UserEdit",
    component: () => import("../views/user/UserEdit.vue"),
  },
  {
    path: "/Recharge",
    name: "Recharge",
    component: () => import("../views/user/Recharge.vue"),
  },
  {
    path: "/Transfer",
    name: "Transfer",
    component: () => import("../views/user/Transfer.vue"),
  },
  {
    path: "/Settings",
    name: "Settings",
    component: () => import("../views/user/Settings.vue"),
  },
  {
    path: "/AccountPwd",
    name: "AccountPwd",
    component: () => import("../views/user/AccountPwd.vue"),
  },
  {
    path: "/MessageList",
    name: "MessageList",
    component: () => import("../views/user/MessageList.vue"),
  },
  {
    path: "/MessageDetails",
    name: "MessageDetails",
    component: () => import("../views/user/MessageDetails.vue"),
  },
  {
    path: "/About",
    name: "About",
    component: () => import("../views/user/About.vue"),
  },
  {
    path: "/Feedback",
    name: "Feedback",
    component: () => import("../views/user/Feedback.vue"),
  },
  {
    path: "/ObitList",
    name: "ObitList",
    component: () => import("../views/discover/obit/ObitList.vue"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/ObitAdd",
    name: "ObitAdd",
    component: () => import("../views/discover/obit/ObitAdd.vue"),
  },
  {
    path: "/ObitDetails",
    name: "ObitDetails",
    component: () => import("../views/discover/obit/ObitDetails.vue"),
  },
  {
    path: "/BirthdayList",
    name: "BirthdayList",
    component: () => import("../views/discover/birthday/BirthdayList.vue"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/ArticleList",
    name: "ArticleList",
    component: () => import("../views/discover/article/ArticleList.vue"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/AlbumList",
    name: "AlbumList",
    component: () => import("../views/discover/album/AlbumList.vue"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/TotalMailbox",
    name: "TotalMailbox",
    component: () => import("../views/discover/mailbox/TotalMailbox.vue"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/Search",
    name: "Search",
    component: () => import("../views/search/Search.vue"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/HotHallList",
    name: "HotHallList",
    component: () => import("../views/search/HotHallList.vue"),
  },
  {
    path: "/Create",
    name: "Create",
    component: () => import("../views/create/Create.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Step01",
    name: "Step01",
    component: () => import("../views/create/Step01.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Step02",
    name: "Step02",
    component: () => import("../views/create/Step02.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Step03",
    name: "Step03",
    component: () => import("../views/create/Step03.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/CreateSuccess",
    name: "CreateSuccess",
    component: () => import("../views/create/CreateSuccess.vue"),
  },
  {
    path: "/Guide",
    name: "Guide",
    component: () => import("../views/login/Guide.vue"),
  },
  {
    path: "/Login",
    name: "Login",
    component: () => import("../views/login/Login.vue"),
  },
  {
    path: "/Register",
    name: "Register",
    component: () => import("../views/login/Register.vue"),
  },
  {
    path: "/ForgetPwd",
    name: "ForgetPwd",
    component: () => import("../views/login/ForgetPwd.vue"),
  },
  {
    path: "/FindPwd",
    name: "FindPwd",
    component: () => import("../views/login/FindPwd.vue"),
  },
  {
    path: "/AgreementPage",
    name: "AgreementPage",
    component: () => import("../views/login/AgreementPage.vue"),
  },
  {
    path: "/PrivacyPage",
    name: "PrivacyPage",
    component: () => import("../views/login/PrivacyPage.vue"),
  },
  {
    path: "/PrivacyPage",
    name: "PrivacyPage",
    component: () => import("../views/login/PrivacyPage.vue"),
  },
  {
    path: "/BookingOrderList",
    name: "BookingOrderList",
    component: () => import("../views/booking/BookingOrderList.vue"),
  },
  {
    path: "/BookingOrderDetails",
    name: "BookingOrderDetails",
    component: () => import("../views/booking/BookingOrderDetails.vue"),
  },
  {
    path: "/BookingForm",
    name: "BookingForm",
    component: () => import("../views/booking/BookingForm.vue"),
  },
  {
    path: "/BookingGoodsList",
    name: "BookingGoodsList",
    component: () => import("../views/booking/BookingGoodsList.vue"),
  },
  {
    path: "/BookingGoodsDetails",
    name: "BookingGoodsDetails",
    component: () => import("../views/booking/BookingGoodsDetails.vue"),
  },
  {
    path: "/QrcodePage",
    name: "QrcodePage",
    component: () => import("../views/user/qrcode/QrcodePage.vue"),
  },
  // {
  //   path: "/MProductList",
  //   name: "MProductList",
  //   component: () =>
  //     import("../views/user/member/MProductList.vue")
  // },
  {
    path: "/MProductDetails",
    name: "MProductDetails",
    component: () => import("../views/user/member/MProductDetails.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/MemberBuy",
    name: "MemberBuy",
    component: () => import("../views/user/member/MemberBuy.vue"),
    mtea:{
      title: "开通会员",
      refresh: false, keepAlive: true
    }
  },
  {
    path: "/TeamIndex",
    name: "TeamIndex",
    component: () => import("../views/user/team/TeamIndex.vue"),
  },
  {
    path: "/TeamList",
    name: "TeamList",
    component: () => import("../views/user/team/TeamList.vue"),
  },
  {
    path: "/MyWallet",
    name: "MyWallet",
    component: () => import("../views/user/wallet/MyWallet.vue"),
  },
  {
    path: "/CashOut",
    name: "CashOut",
    component: () => import("../views/user/wallet/CashOut.vue"),
  },
  {
    path: "/CashRecord",
    name: "CashRecord",
    component: () => import("../views/user/wallet/CashRecord.vue"),
  },
  {
    path: "/BankAdd",
    name: "BankAdd",
    component: () => import("../views/user/wallet/BankAdd.vue"),
  },
  {
    path: "/BankEdit",
    name: "BankEdit",
    component: () => import("../views/user/wallet/BankEdit.vue"),
  },
  {
    path: "/BankList",
    name: "BankList",
    component: () => import("../views/user/wallet/BankList.vue"),
  },
  {
    path: "/CommissionDetails",
    name: "CommissionDetails",
    component: () => import("../views/user/commission/CommissionDetails.vue"),
    meta: {
      keepAlive: true,
      isBack: false,
    },
  },
  {
    path: "/DateFilter",
    name: "DateFilter",
    component: () => import("../views/user/commission/DateFilter.vue"),
  },

  {
    path: "/CommissionGiveDetails",
    name: "CommissionGiveDetails",
    component: () =>
      import("../views/user/commission_give/CommissionGiveDetails.vue"),
  },
  {
    path: "/OrderList",
    name: "OrderList",
    component: () => import("../views/user/order/OrderList.vue"),
  },
  {
    path: "/PreMemorialHall",
    name: "PreMemorialHall",
    component: () =>
      import("../views/memorialhall/preview/preMemorialHall.vue"),
  },
  {
    path: "/PreCemetery",
    name: "PreCemetery",
    component: () => import("../views/memorialhall/preview/preCemetery.vue"),
  },
  {
    path: "/PreWorship",
    name: "PreWorship",
    component: () => import("../views/memorialhall/preview/preWorship.vue"),
  },
  {
    path: "/AuthPhoneUser",
    name: "AuthPhoneUser",
    component: () => import("../views/login/AuthPhoneUser.vue"),
  },
  {
    path: "/NotPublic",
    name: "NotPublic",
    component: () => import("../views/status/NotPublic.vue"),
  },
  {
    path: "/AddressManage",
    name: "AddressManage",
    component: AddressManage,
    meta: { title: "地址管理", isBack: true }
  },
  {
    path: "/AddressAdd",
    name: "AddressAdd",
    component: AddressManageAdd,
  },
  {
    path: "/AddressEdit",
    name: "AddressEdit",
    component: AddressManageEdit,
  },
  {
    path: "/accountManage",
    name: "AccountManage",
    component: () => import("../views/user/accountManage/Index.vue"),
    meta: { title: "账户管理" },
  },
  {
    path: "/bindAlipay",
    name: "BindAlipay",
    component: () => import("../views/user/accountManage/BindAlipay.vue"),
    meta: { title: "绑定支付宝" },
  },
  {
    path: "/bindBankCard",
    name: "BindBankCard",
    component: () => import("../views/user/accountManage/BindBankCard.vue"),
    meta: { title: "绑定银行卡" },
  },
  {
    path: "/commission",
    name: "Commission",
    component: () => import("../views/user/commission/Index.vue"),
    meta: { title: "佣金记录" },
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Logout.vue"),
    meta: { title: "账号退出" },
  },
  {
    path:"/withdrawal",
    name:"Withdrawal",
    component: () => import("../views/user/withdrawal/Index.vue"),
    meta: { title: "提现" }
  },
  {
    path: "/WithdrawalList",
    name: "WithdrawalList",
    component: () => import("../views/user/withdrawal/List.vue"),
    meta: { title: "提现明细" }
  },
  {
    path: "/memberList",
    name: "MemberList",
    component: () => import("../views/user/memberList/Index.vue"),
    meta: { title: "我的用户" }
  },
  {
    path: "/memberDetail2s",
    name: "MemberDetail2s",
    component: () => import("../views/user/MemberDetail2s.vue"),
    meta: { title: "佣金详情" }
  },
  {
    path: "/jifenDetails",
    name: "JifenDetails",
    component: JifenDetails,
    meta: { title: "积分明细" }
  },
  {
    path: "/jifenGiveForm",
    name: "JifenGiveForm",
    component: JifenGiveForm,
    meta: { title: "积分转赠" }
  },
  {
    path: "/yeGiveForm",
    name: "YeGiveForm",
    component: yeGiveForm,
    meta: { title: "余额转积分" }
  },
  {
    path: "/yeGiveForm2",
    name: "YeGiveForm2",
    component: yeGiveForm2,
    meta: { title: "积分转余额" }
  },
  {
    path: "/yeGive",
    name: "YeGive",
    component: yeGive,
    meta: { title: "转换明细" }
  },
  {
    path:"/jifenGive",
    name:"JifenGive",
    component:JifenGive,
    meta: { title: "转换明细" }
  },
  {
    path:"/zy",
    name:"Zy",
    component:Zy,
    meta: { title: "中元节", keepAlive: true }
  },
  {
    path:"/zy/test",
    name:"ZyTest",
    component:ZyTest,
    meta: { title: "中元节 test" }
  },
  {
    path:"/signIn",
    name:"SignIn",
    component:SignIn,
    meta: { 
      title: "签到中心",
      requiresAuth: true
    }
  },
  {
    path:"/memorialHallApply",
    name:"MemorialHallApply",
    component:MemorialHallApply,
    meta: { 
      title: "公开纪念馆申请",
      requiresAuth: true
    }
  },
  {
    path: "/memberTeamDetails",
    name: "MemberTeamDetails",
    component: () => import("../views/user/MemberTeamDetails.vue"),
    meta: { title: "佣金详情", keepAlive: true,refresh: false }
  },
  {
    path:"/frienMemberTeam",
    name:"FrienMemberTeam",
    component: () => import("../views/memorialhall/frienMemberTeam/index.vue"),
    meta: { title: "亲友团" }
  },
  {
    path:"/frienShare",
    name:"FrienShare",
    component: () => import("../views/memorialhall/share/Index.vue"),
    meta: { title: "邀请亲友" }
  },
  {
    path:"/memorialHallValidate",
    name:"MemorialHallValidate",
    component: () => import("../views/memorialhall/MemorialHallValidate.vue"),
    meta: { title: "亲友团" }
    
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/404.vue"),
    meta: { title: "页面错误" },
  },
  {
    path: "/test",
    name: "test",
    component: () => import("../views/test.vue"),
    meta: { title: "测试" },
  },
  { path: "*", redirect: "/404", hidden: true },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  strict: process.env.NODE_ENV !== "production",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    var accessToken = JSON.parse(localStorage.getItem("accessToken"));
    if (accessToken == null) {
      //判断是否获取accessToken
      if (to.name == "Home") {
        next({
          path: "/Guide", //主页跳转
          query: { ReturnUrl: to.fullPath },
        });
      }
      else {
        next({
          path: "/login", //登录跳转
          query: { ReturnUrl: to.fullPath },
        });
      }
    } else {
      next();
    }
  } else {
    // console.log("~~~~~~~~~~~~~~~~beforeEach~~~~~~~~~~~~~~~~~")
    // console.log(from);
    // console.log(to);
    // console.log("~~~~~~~~~~~~~~~~~beforeEach~~~~~~~~~~~~~~~~")
    next();
  }
});

export default router;
